module.exports = __webpack_public_path__ + "img/bronze.a941760d.svg";